import { useCallback, useState } from "react";

import { useAccountDetailData } from "./useAccountDetailData";

/**
 * 账号详情 Modal：Tab 状态 + 详情数据
 * @param id 业务账号 ID
 */
export const useAccountDetail = (id?: string) => {
  const { accountDetail, loading, reload } = useAccountDetailData(id, Boolean(id));
  // 当前 Tab key
  const [detailTab, setDetailTab] = useState("basic");

  /** 状态切换后重新拉取账号详情 */
  const reloadAccountDetail = useCallback(async () => {
    if (!id) return;
    await reload(id);
  }, [id, reload]);

  return {
    detailTab,
    setDetailTab,
    accountDetail,
    loading,
    reloadAccountDetail,
  };
};
